import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@heroui/react';
import { ROUTES } from '@/shared/config';
import { PageLayout } from '@/shared/ui';

/**
 * Экран, пока грузится чанк страницы (`lazyPage` в `app/router`): та же шапка
 * и тот же скелет, что `SettingsPage` показывает, пока ждёт настройки, —
 * чтобы загрузка кода и загрузка данных шли одним шиммером.
 */
export function SettingsPageSkeleton() {
  const { t } = useTranslation('SettingsPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('title')} onBack={() => void navigate(ROUTES.profile)}>
      <SettingsSkeleton />
    </PageLayout>
  );
}

/**
 * Один серый блок на группу — высота подогнана под реальную (60px на строку,
 * см. `SettingsRow`), поэтому подстановка настоящих данных не двигает
 * страницу.
 */
export function SettingsSkeleton() {
  return (
    <div className="flex flex-col gap-5" aria-busy="true" aria-live="polite">
      <SettingsSectionSkeleton headerWidth="w-12" blockHeight="h-[121px]" />
      <SettingsSectionSkeleton headerWidth="w-20" blockHeight="h-[60px]" />
      <SettingsSectionSkeleton headerWidth="w-32" blockHeight="h-[60px]" hint />
      <SettingsSectionSkeleton headerWidth="w-44" blockHeight="h-[60px]" hint />
      <SettingsSectionSkeleton headerWidth="w-24" blockHeight="h-[60px]" hint />
    </div>
  );
}

function SettingsSectionSkeleton({
  headerWidth,
  blockHeight,
  hint,
}: {
  headerWidth: string;
  blockHeight: string;
  hint?: boolean;
}) {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className={`h-3 ${headerWidth} rounded-full`} />
      <Skeleton className={`${blockHeight} rounded-2xl`} />
      {hint && <Skeleton className="h-3 w-4/5 rounded-full" />}
    </div>
  );
}
